<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="tabClick" closable @tab-remove="removeTab">
      <el-tab-pane v-for="item in $store.state.tab.tabList" :key="item.path" :label="item.title" :name="item.name"></el-tab-pane>
    </el-tabs>
    
    <div class="tab-content">
      <div v-if="activeName !== 'home' || $route.name === 'out'">
        <router-view v-if="$route.meta.keepAlive === false"></router-view>
        <keep-alive>
          <router-view :key="$route.name" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </div>
      
      <div v-else>
        <keep-alive>
          <Desktop></Desktop>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Desktop from '../components/desktop';
import common from '../utils/common';
export default {
  components: { Desktop },
  
  data() {
    return {
      activeName: this.$store.state.tab.currentMenu
    }
  },
  
  watch: {
    '$store.state.tab.currentMenu'(newVal, olVal) {
      this.activeName = newVal;
    },
  },
  
  methods: {
    tabClick() {
      this.$store.commit('setCurrentMenu', this.activeName);
      this.$router.push({ name: this.activeName });
    },
    
    removeTab(targetName) {
      if (targetName === 'home') return;

      let self = null;
      for (let i = 0; i < this.$children[0].panes.length; i++) {
        if (this.$children[0].panes[i].name === targetName) {
          let selfTab = this.$children[0].panes[i];

          for (let j = 0; j < this.$parent.$children[0].$children.length; j++){
            if (selfTab.name === this.$parent.$children[0].$children[j].$vnode.data.key){
              self = this.$parent.$children[0].$children[j];
              break;
            }
          }

        }
      }

      //删除标签，如果只有一个标签，则不会执行删除
      let tabs = this.$store.state.tab.tabList;
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          let nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            this.$store.commit('delTag', tab);
            this.$store.commit('setCurrentMenu', nextTab.name);
            this.$router.push({ name: nextTab.name });
          }
        }
      });
          
      if (self == null) return;

      let vnode = self.$vnode;
      let parentVnode = vnode.parent;

      if (parentVnode && parentVnode.componentInstance.cache) {
        let key = vnode.key == null ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '') : vnode.key;

        let cache = parentVnode.componentInstance.cache;
        let keys = parentVnode.componentInstance.keys;

        if (cache[key]) {
          self.$destroy();
          if (keys.length) {
            let index = keys.indexOf(key)
            if (index > -1) {
              keys.splice(index, 1);
            }
          }
          cache[key] = null;
        }
      }
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/tab.vue